import type { ReactNode } from 'react'
import { useModeStore } from '@stores/modeStore.js'

interface Props {
  children: ReactNode
  variant?: 'default' | 'guia-hero' | 'obra-hero' | 'passo'
  className?: string
}

export function PageShell({ children, variant = 'default', className = '' }: Props) {
  const mode = useModeStore((s) => s.mode)
  const cls = [
    'cf3-page',
    `cf3-page--${mode}`,
    variant !== 'default' ? `cf3-page--${variant}` : '',
    className,
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <div className={cls}>
      <div className='cf3-page__inner'>{children}</div>
    </div>
  )
}
